'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../../../util');

var _util2 = _interopRequireDefault(_util);

var _input = require('../../../../input');

var _input2 = _interopRequireDefault(_input);

var _lodashCompat = require('lodash-compat');

var _icon = require('../../../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _data = require('../../../../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var SelectFilter = (_temp = _class = function (_M$BaseComponent) {
  _inherits(SelectFilter, _M$BaseComponent);

  function SelectFilter(props) {
    _classCallCheck(this, SelectFilter);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SelectFilter).call(this, props));

    var model = props.model;

    var _ref = model || {};

    var filteredFullValue = _ref.filteredFullValue;
    var filters = _ref.filters;
    var filterModel = _ref.filterModel;
    //如果有传入onFetchData，则默认不使用filters的数据

    var data = (0, _lodashCompat.isFunction)(filterModel.onFetchData) ? [] : (0, _lodashCompat.isArray)(filters) ? filters.slice() : [];
    Object.assign(_this.state, {
      data: data,
      showData: _this._getShowData(data, filterModel),
      value: filteredFullValue && filteredFullValue[0] || null,
      keyword: '',
      loading: false,
      showSearch: filterModel.showSearch });
    return _this;
  }

  _createClass(SelectFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      //如果不显示搜索框，则在组件刚加载时获取数据
      if (!this.state.showSearch) {
        this._fetchData();
      } else {
        //FIXME 直接调用会使得页面滚动到顶部
        this.setTimeout(function () {
          _this2.refs.input.focus();
        }, 0);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var model = nextProps.model;

      var _ref2 = model || {};

      var filteredFullValue = _ref2.filteredFullValue;

      this.setState({
        value: filteredFullValue && filteredFullValue[0] || null
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var model = this.props.model;

      var _ref3 = model || {};

      var filterModel = _ref3.filterModel;

      var _ref4 = filterModel || {};

      var placeholder = _ref4.placeholder;
      var format = _ref4.format;
      var _state = this.state;
      var v = _state.value;
      var keyword = _state.keyword;
      var showData = _state.showData;
      var loading = _state.loading;
      var showSearch = _state.showSearch;

      var baseCls = 'select-filter';

      var listItems = void 0;
      if (loading) {
        listItems = _react2.default.createElement(
          'li',
          { className: baseCls + '__loading' },
          _react2.default.createElement(_icon2.default, { className: baseCls + '__loading-icon', type: 'loading' })
        );
      } else if (!showSearch && (!showData || showData.length == 0)) {
        //既不显示搜索框又没有data的时候，也非loading时
        return null;
      } else {
        listItems = (showData || []).map(function (d, i) {
          var label = d.label;
          var value = d.value;


          return _react2.default.createElement(
            'li',
            { key: i,
              className: _util2.default.classNames(baseCls + '__item', {
                active: value == (v && v.value)
              }),
              onClick: _this3._onClick.bind(_this3, d, i),
              title: label },
            format ? (0, _data.getComponent)(format, d) : label
          );
        });
      }

      return _react2.default.createElement(
        'div',
        { className: baseCls },
        showSearch && _react2.default.createElement(
          'div',
          { className: baseCls },
          _react2.default.createElement(_input2.default, { ref: 'input',
            className: baseCls + '__input',
            size: 'small',
            value: keyword,
            placeholder: placeholder,
            trigger: 'onChange',
            onChange: this._onChange })
        ),
        _react2.default.createElement(
          'ul',
          { className: baseCls + '__list' },
          listItems
        )
      );
    }
  }, {
    key: '_onClick',
    value: function _onClick(v) {
      var onConfirm = this.props.onConfirm;

      onConfirm && onConfirm(v);
    }
  }, {
    key: '_onChange',
    value: function _onChange(keyword) {
      var _this4 = this;

      this.setState({ keyword: keyword }, function () {
        _this4.timeout && clearTimeout(_this4.timeout);
        _this4.timeout = _this4.setTimeout(_this4._fetchData, _this4.props.delay);
      });
    }
  }, {
    key: '_fetchData',
    value: function _fetchData() {
      return new Promise(function ($return, $error) {
        var _this5 = this;

        var keyword = this.state.keyword;
        var filterModel = this.props.model.filterModel;
        var onFetchData = filterModel.onFetchData;
        var noSearchIfNoKeyword = filterModel.noSearchIfNoKeyword;

        function $IfStatement_3() {
          return $return();
        }

        if ((0, _lodashCompat.isFunction)(onFetchData) && (!noSearchIfNoKeyword || keyword.length !== 0)) {
          var $Try_1_Finally;
          var $Try_1_Catch;

          var _ret = function () {
            var $Try_1_Post = function $Try_1_Post() {
              return $IfStatement_3.call(this);
            };

            $Try_1_Finally = function ($Try_1_Exit) {
              return function ($Try_1_Value) {
                this.setState({ loading: false });
                return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
              }.$asyncbind(this, $error);
            }.$asyncbind(_this5);

            $Try_1_Catch = function ($exception_2) {
              return $Try_1_Finally($error)($exception_2);
            }.$asyncbind(_this5, $Try_1_Finally($error));

            try {
              _this5.setState({ loading: true });
              return {
                v: Promise.resolve(onFetchData(keyword)).then(function ($await_4) {
                  var res = $await_4;
                  if (res) {
                    this.setState({
                      data: res,
                      showData: this._getShowData(res, filterModel)
                    });
                  }
                  return $Try_1_Finally($Try_1_Post).call(this);
                }.$asyncbind(_this5, $Try_1_Catch), $Try_1_Catch)
              };
            } catch ($exception_2) {
              $Try_1_Catch($exception_2)
            }
          }();

          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
        return $IfStatement_3.call(this);
      }.$asyncbind(this));
    }
  }, {
    key: '_getShowData',
    value: function _getShowData(data, model) {
      var idField = model.idField;
      var showField = model.showField;

      return (data || []).map(function (d) {
        return _extends({}, d, { label: d[showField], value: d[idField] });
      });
    }
  }]);

  return SelectFilter;
}(_util2.default.BaseComponent), _class.defaultProps = {
  delay: 500
}, _temp);
exports.default = SelectFilter;